<template>
  <sui-segment emphasis="secondary" class="entity">
    <FormService v-model="$attrs.value" :schema="$attrs.value.schema" mode="importing" @input="$emit('input', $attrs.value)" />
  </sui-segment>
</template>

<script>
  import FormService from '@/components/forms/Service'
  export default {
    name: 'FormStackService',
    components: {
      FormService,
    },
  }
</script>

<style scoped>
  .segment >>> h3 { display: none!important; }
  .segment >>> .segment { margin: 0!important; padding: 0!important; border: none!important; box-shadow: none!important; }
  .segment >>> h3 + .segment { margin-bottom: 1em!important; }
</style>
